<template>
  <div :class="[homeStyle ? 'home-style' : '', 'point-price']" v-if="product.price">
    <div>
      <!-- <p class="price-warp">
        <span class="origin-price" v-if="showOriginPrice">原价:￥{{ originPrice }}</span>
        <span class="real-price"><span class="rmb">￥</span>{{ realPrice }}</span>
      </p> -->
      <p class="price-warp">
        <span class="origin-price"></span>
        <span class="real-price"><span class="rmb">原价：￥</span>{{ originPrice }}</span>
      </p>
      <template v-if="showRatio">
        <span class="points" v-if="memberRatio != 0">
          <span>会员积分抵扣</span>
          <span class="points-num">{{ memberRatio }}%</span>
        </span>
      </template>
      <template v-if="!showRatio">
        <span class="points" v-if="product.memberRatio != 0"> +{{ pointsDeduction }}积分</span>
      </template>
    </div>
    <!-- <p class="origin-price" v-if="showOriginPrice">原价:￥{{ originPrice }}</p> -->
  </div>

  <!-- <p>
    <span class="points" v-if="memberRatio != 0"> 积分{{ memberRatio }}% + </span><span>￥{{ realPrice }}</span>
  </p> -->
</template>

<script>
export default {
  data() {
    return {
      showRatio: true
    };
  },
  props: {
    homeStyle: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    realPrice() {
      let price = (this.product.price - this.product.price * this.product.memberRatio).toFixed(2);
      if (price === '0.00') {
        price = 0;
      }
      return price;
    },
    pointsDeduction() {
      return (this.product.price * this.product.memberRatio).toFixed(0);
    },
    originPrice() {
      return Number(this.product.price).toFixed(2);
    },
    showOriginPrice() {
      return this.realPrice !== this.originPrice;
    },
    memberRatio() {
      return (this.product.memberRatio * 100).toFixed(0);
    }
  },
  async mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.point-price {
  .rmb {
    font-size: 10px;
    color: $red1;
  }
  .real-price {
    font-size: $size1;
    color: $red1;
  }

  .points {
    font-size: 12px;
    color: $gray2;
    margin-top: 8px;
    display: inline-block;
    color: #6ea62c;

    .points-num {
      font-weight: 700;
    }
  }

  .origin-price {
    font-size: 12px;
    color: $gray2;
    margin-top: 6px;
    margin-right: 6px;
    text-decoration: line-through;
  }
}

.home-style {
  padding: 0 8px 8px;
  .price-warp {
    display: flex;
    justify-content: space-between;
  }
  .point-price {
    width: 100%;
  }
  .points {
    text-align: right;
    width: 100%;
  }
}
</style>
